import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=3e3c87bc&scoped=true&"
import script from "./phone.vue?vue&type=script&lang=js&"
export * from "./phone.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/web/account/settings/_content.scss?vue&type=style&index=0&id=3e3c87bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3c87bc",
  null
  
)

export default component.exports